import React, { createContext, useContext, type ReactNode } from 'react';
import { fg } from '@atlassian/jira-feature-gating';

type FeatureVisibilityData = {
	hasViews: boolean;
	hasChannels: boolean;
	hasEssentials: boolean;
	hasPractices: boolean;
	hasCustomerService: boolean;
	hasOperations: boolean;
	hasLabs: boolean;
};

export const defaultFeatureVisibility = {
	hasViews: true,
	hasChannels: true,
	hasEssentials: true,
	hasPractices: true,
	hasCustomerService: true,
	hasOperations: true,
	hasLabs: true,
};

const FeatureVisibilityContext = createContext<FeatureVisibilityData>(defaultFeatureVisibility);
export const useFeatureVisibilityContext = () => useContext(FeatureVisibilityContext);

export const useFeatureVisibility = () => {
	if (!fg('jcs_master_flag')) {
		return defaultFeatureVisibility;
	}

	// eslint-disable-next-line react-hooks/rules-of-hooks
	return useFeatureVisibilityContext();
};

type Props = Partial<FeatureVisibilityData> & {
	children: ReactNode;
};

export const FeatureVisibilityProvider = ({ children, ...props }: Props) => {
	if (!fg('jcs_master_flag')) {
		return children;
	}

	return (
		<FeatureVisibilityContext.Provider value={{ ...defaultFeatureVisibility, ...props }}>
			{children}
		</FeatureVisibilityContext.Provider>
	);
};
